import { render } from "./LoaderComponent.vue?vue&type=template&id=be9520fa&ts=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=ts"
export * from "./LoaderComponent.vue?vue&type=script&lang=ts"

import "./LoaderComponent.vue?vue&type=style&index=0&id=be9520fa&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/general/LoaderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be9520fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be9520fa', __exports__)) {
    api.reload('be9520fa', __exports__)
  }
  
  module.hot.accept("./LoaderComponent.vue?vue&type=template&id=be9520fa&ts=true", () => {
    api.rerender('be9520fa', render)
  })

}


export default __exports__